import { IChartContainer } from "../models/base/chart-container.interface";
import { DrawTradePriceAnnotationModel } from "../models/draw-trade-order/draw-trade-price-annotation.model";
import { IComponent } from "./component.interface";

export class DrawTradePriceAnnotationComponent implements IComponent {
    public id = '';

    private element: HTMLElement | null = null;
    private base: IChartContainer;

    private annotations: Array<DrawTradePriceAnnotationModel> = [];
    // private originalAnnotations: Array<DrawTradePriceAnnotationModel> = [];
    private isRemovingForSwitchingSymbol = false;

    constructor(base: IChartContainer) {
        this.base = base;
        // this.subscribeFake();
        this.subscribe();
        this.base.tiChartSeries?.subscribeExtremeChange(() => {
            setTimeout(() => {
                this.setPosition();
            }, 50);
        });
        this.onResize();
    }

    public createElement() {
        const element = document.createElement('div');
        element.className = 'trade-order-price-annotations';

        const highchartContainer = this.base.tiChartSeries.element.findFirst('.highcharts-container');
        if (highchartContainer) {
            highchartContainer.insertAdjacentElement('beforeend', element);
            this.element = element;
            this.isRemovingForSwitchingSymbol = false;
        }
    }

    public remove() {
        this.isRemovingForSwitchingSymbol = true;
        this.element?.setInnerHtml('');
        this.element?.remove();
        this.annotations = [];
        // this.originalAnnotations = [];

        this.isRemovingForSwitchingSymbol = false;
    }

    // private subscribeFake() {
    //     setTimeout(() => {
    //         this.annotations = [
    //             new DrawTradePriceAnnotationModel({
    //                 name: "FAKE",
    //                 color: { r: 41, g: 98, b: 255 },
    //                 label: "123 AI",
    //                 y: 397.5,
    //                 x: 320
    //             })
    //         ];

    //         console.log('annotations ', this.annotations);
    //         this.draw();
    //     }, 5000);
    // }

    private subscribe() {
        this.base.chartService.subscribeDrawTradePriceAnnotations((data: Array<DrawTradePriceAnnotationModel>) => {
            if (this.isRemovingForSwitchingSymbol) {
                return;
            }

            this.annotations = data;

            // for (const item of data) {
            //     if (!this.originalAnnotations.some((x: DrawTradePriceAnnotationModel) => x.name == item.name)) {
            //         this.originalAnnotations.push(item);
            //     }
            // }

            this.draw();
        });
    }

    private draw() {
        this.element?.setInnerHtml('');

        const template = `<div class="last-price-wrapper {class}">
            <div class="last-price">
                <p>{value}</p>
                <div class="line"></div>
            </div>
        </div>
        <style>
            .last-price-wrapper.{class} {
                background-color: var(--{class}-bg-color);
            } 
            .last-price-wrapper.{class} .line {
                position: absolute;
                right: 0px;
                top: 50%;
                background-color: var(--{class}-bg-color);
                height: 1px;
            }
            .last-price-wrapper.{class} .last-price p {
                z-index: 1;
                position: relative;
            }
            .last-price-wrapper.{class} .last-price:before {
                border-color: transparent var(--{class}-bg-color) transparent transparent;
            }
        </style>`;

        const root = document.documentElement;

        for (const item of this.annotations) {
            const className = item.name.split(' ').join('').replace(/[^\w\s]/gi, '').toLowerCase();
            const html = template.split('{class}').join(className).replace('{value}', item.label);

            root.style.setProperty('--' + className + '-bg-color', item.color.toRGB());

            const div = document.createElement('div');
            div.className = 'annotation ' + className;
            div.innerHTML = html;

            item.element = div;
            this.element?.insertAdjacentElement('beforeend', div);
        }

        this.setPosition();
    }

    public setPosition() {
        if (!this.base.tiChartSeries || !this.base.tiChartSeries.chartStyleSettings || !this.base.tiChartSeries.highStockChart?.yAxis?.length || !this.base.tiChartSeries.highStockChart?.xAxis?.length || !this.annotations?.length) {
            return;
        }

        const mainChartSerie: any = this.base.tiChartSeries.highStockChart.series[0]
        const yAxis: any = this.base.tiChartSeries.highStockChart.yAxis[0]
        const xAxis = this.base.tiChartSeries.highStockChart.xAxis[0]

        for (const item of this.annotations) {
            if (!item.element) {
                continue;
            }

            const currentYValue = yAxis.toPixels(item.y) ?? 0;
            const myHeight = 7;

            const valueTop = (yAxis.toPixels(yAxis.max) ?? 0) - 16;
            const valueBottom = (yAxis.toPixels(yAxis.min) ?? 0) - 16;

            let top = currentYValue - myHeight;
            let hide = false;
            let hideLine = false;

            if (item.y > yAxis.max || valueTop > top) {
                top = valueTop;
                hide = true;
            } else if (item.y < yAxis.min || top > valueBottom) {
                top = valueBottom;
                hide = true;
            }

            const itemX = this.annotations.find((x: DrawTradePriceAnnotationModel) => x.name == item.name)?.x ?? item.x;
            const roundedX = Math.round(itemX);
            // console.log('draw-trade-price-annotation roundedX ', roundedX)

            const currentXValue = xAxis.toPixels(roundedX, false) ?? 0;
            let width = Math.abs(this.base.tiChartSeries.element.clientWidth - currentXValue);

            const lastProcessedXData = mainChartSerie.processedXData[mainChartSerie.processedXData.length - 1];
            if (lastProcessedXData < roundedX) {
                hideLine = true;
            } else if (!mainChartSerie.processedXData.some((x: number) => x == roundedX)) {
                width = this.base.tiChartSeries.element.clientWidth;
                // console.log('draw-trade-price-annotation processedXData not found ')
            }

            item.element.findFirst('p')?.ifExistThen((el: HTMLElement) => {
                el.setInnerHtml(item.label);
            });

            item.element.findFirst('.last-price-wrapper')?.ifExistThen((el: HTMLElement) => {
                el.style.top = top + 'px';
            });

            const point = mainChartSerie.points.find((x: any) => x.x == roundedX);
            const spacingRight = this.base.tiChartSeries.chartStyleSettings.showSmartRiskLevel ? 92 : 62;
            item.element.findFirst('.line')?.ifExistThen((el: HTMLElement) => {
                if (hideLine) {
                    el.style.width = '0px';
                    return;
                }

                // console.log('draw-trade-price-annotation point ', point)
                const pointWidth = point && point.pointWidth ? point.pointWidth / 2 : 0;
                el.style.width = width > 0 ? (width + spacingRight + pointWidth) + 'px' : '0px';
            });

            if (hide) {
                item.element.addClass('hidden');
            } else {
                item.element.removeClass('hidden');
            }
        }
    }

    private resizeTimmer = null as any;
    private onResize() {
        this.base.domEvents.onResize(() => {
            clearTimeout(this.resizeTimmer);
            this.resizeTimmer = setTimeout(() => {
                this.setPosition();
            }, 50);
        });
    }
}